export default defineNuxtPlugin(async (nuxtApp) => {
    const { user, refreshIdentity } = useSanctumAuth();

    if (!user.value) {
        try {
            await refreshIdentity();
        } catch {
            // Unauthenticated guest or expired session
        }
    }
})
